import { useQuery } from 'react-query';
import { queryKeys } from './QueryClient';
import { useMoralis } from 'react-moralis';
import { referralCode, referralRewards } from '../utils/PointsAPI';
import { useUser } from 'hooks/useUser';

export const REFERRAL_LOCAL_STORAGE = 'referralCode';
export const POINTS_PER_REFERRAL = 500;

export const getReferralId = (): string | null => {
  return localStorage.getItem(REFERRAL_LOCAL_STORAGE);
};

export const setReferralId = (id: string): void => {
  localStorage.setItem(REFERRAL_LOCAL_STORAGE, id);
};

export const deleteReferralId = (): void => {
  localStorage.removeItem(REFERRAL_LOCAL_STORAGE);
};

const getUserReferralLink = async (userId: string): Promise<string> => {
  const code = await referralCode(userId);
  return `${window.location.origin}/ref/${code}`;
};

export const useUserReferral = () => {
  const { isAuthenticated } = useMoralis();
  const { account } = useUser();
  const userId = account.dusktech?.userId;

  const referralCodeQuery = useQuery(
    queryKeys.referralCode(userId!),
    () => {
      if (!userId) {
        throw Error('No userId');
      }
      return getUserReferralLink(userId);
    },
    {
      enabled: isAuthenticated && userId !== undefined,
    },
  );

  const rewardsQuery = useQuery(
    queryKeys.referralRewards(userId!),
    () => {
      if (!userId) {
        throw Error('No userId');
      }
      return referralRewards(userId);
    },
    {
      enabled: isAuthenticated && userId !== undefined,
    },
  );

  return {
    referralCode: { ...referralCodeQuery },
    rewards: { ...rewardsQuery },
  };
};
